export enum ChallengeCategory {
  MarketingCopy = "marketing_copy",
  TweetsSubstack = "tweets_substack",
  Poem = "poem",
}

export const CategoryLabels = {
  [ChallengeCategory.MarketingCopy]: "Marketing Copy",
  [ChallengeCategory.TweetsSubstack]: "Tweets/Substack",
  [ChallengeCategory.Poem]: "Poetry",
};
